import { render, staticRenderFns } from "./CmgCheckoutPaymentHeader.vue?vue&type=template&id=a2e54682&scoped=true&lang=pug&"
import script from "./cmg-checkout-payment-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-payment-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutPaymentHeader.vue?vue&type=style&index=0&id=a2e54682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e54682",
  null
  
)

export default component.exports